import { render } from "./RSVPForm.vue?vue&type=template&id=8b515ad4&scoped=true"
import script from "./RSVPForm.vue?vue&type=script&lang=js"
export * from "./RSVPForm.vue?vue&type=script&lang=js"

import "./RSVPForm.vue?vue&type=style&index=0&id=8b515ad4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b515ad4"]])

export default __exports__